module.exports = __webpack_public_path__ + "static/img/profile05.5824e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/pc/profile05.png
// module id = 0CKJ
// module chunks = 10